import "./landing-page-arrowed-list.component.scss";

export default {
    template: require('./landing-page-arrowed-list.component.html'),
    transclude: true,
    controller: function () {
        'ngInject';
    }
};
